import _classCallCheck from "/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
// Extensions
import { Service } from '../service'; // Utilities

import { getObjectValueByPath } from '../../util/helpers';
import { consoleError, consoleWarn } from '../../util/console';
var LANG_PREFIX = '$vuetify.';
var fallback = Symbol('Lang fallback');
function getTranslation(locale, key) {
  var usingDefault = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var defaultLocale = arguments.length > 3 ? arguments[3] : undefined;
  var shortKey = key.replace(LANG_PREFIX, '');
  var translation = getObjectValueByPath(locale, shortKey, fallback);
  if (translation === fallback) {
    if (usingDefault) {
      consoleError("Translation key \"".concat(shortKey, "\" not found in fallback"));
      translation = key;
    } else {
      consoleWarn("Translation key \"".concat(shortKey, "\" not found, falling back to default"));
      translation = getTranslation(defaultLocale, key, true, defaultLocale);
    }
  }
  return translation;
}
export var Lang = /*#__PURE__*/function (_Service) {
  _inherits(Lang, _Service);
  var _super = _createSuper(Lang);
  function Lang(preset) {
    var _this;
    _classCallCheck(this, Lang);
    _this = _super.call(this);
    _this.defaultLocale = 'en';
    var _preset$Lang$property = preset[Lang.property],
      current = _preset$Lang$property.current,
      locales = _preset$Lang$property.locales,
      t = _preset$Lang$property.t;
    _this.current = current;
    _this.locales = locales;
    _this.translator = t || _this.defaultTranslator;
    return _this;
  }
  _createClass(Lang, [{
    key: "currentLocale",
    value: function currentLocale(key) {
      var translation = this.locales[this.current];
      var defaultLocale = this.locales[this.defaultLocale];
      return getTranslation(translation, key, false, defaultLocale);
    }
  }, {
    key: "t",
    value: function t(key) {
      for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        params[_key - 1] = arguments[_key];
      }
      if (!key.startsWith(LANG_PREFIX)) return this.replace(key, params);
      return this.translator.apply(this, [key].concat(params));
    }
  }, {
    key: "defaultTranslator",
    value: function defaultTranslator(key) {
      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        params[_key2 - 1] = arguments[_key2];
      }
      return this.replace(this.currentLocale(key), params);
    }
  }, {
    key: "replace",
    value: function replace(str, params) {
      return str.replace(/\{(\d+)\}/g, function (match, index) {
        /* istanbul ignore next */
        return String(params[+index]);
      });
    }
  }]);
  return Lang;
}(Service);
Lang.property = 'lang';